/**
 * BodySlider Component
 *
 * Main slider component that displays body images with face overlays.
 * Uses keen-slider for smooth sliding animations.
 */
import React from "react";
import FaceOverlay from "./FaceOverlay";

const BodySlider = ({
  sliderRef,
  images,
  imageRefs,
  containerRefs, // refs for each container
  selectedFace,
  showFaces,
  selectedEffect,
  showSpecialEffect,
  calculateFaceStyle,
}) => {
  return (
    <div ref={sliderRef} className="keen-slider minimove-bodygallery-slider">
      {images.map((item, idx) => (
        <div
          key={idx}
          className="keen-slider__slide minimove-bodygallery-slide"
          data-slide={idx}
        >
          <div
            className="image-wrapper"
            style={{ position: "relative" }}
            ref={containerRefs[idx]}
          >
            {/* Body image */}
            <img
              ref={imageRefs[idx]}
              src={item.url}
              alt={`Body ${idx}`}
              className="minimove-bodygallery-image"
              data-index={idx}
              onLoad={() => {}}
              onError={(e) => {
                e.target.src =
                  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='300' fill='%23cccccc'%3E%3Ctext x='50%' y='50%' dominant-baseline='middle' text-anchor='middle' fill='%23333333' font-family='sans-serif' font-size='24'%3EError%3C/text%3E%3C/svg%3E";
              }}
            />

            {/* Face overlay */}
            {selectedFace &&
              showFaces &&
              imageRefs[idx]?.current &&
              containerRefs[idx]?.current && (
                <FaceOverlay
                  style={calculateFaceStyle(
                    imageRefs[idx].current, // DOM element of the body image
                    containerRefs[idx].current, // DOM element of the specific container
                    item, // image data (bodyImage)
                    selectedFace,
                    showSpecialEffect,
                    selectedEffect,
                    idx
                  )}
                  isSpecialEffect={idx === 0 && showSpecialEffect}
                />
              )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default BodySlider;
